// Đọc claims của JWT phía client (KHÔNG verify chữ ký — chỉ dùng để quyết định UI,
// backend vẫn tự kiểm tra). Trả null nếu token rỗng/sai định dạng.
export const decodeJwtClaims = (token) => {
  try {
    const raw = String(token || "").replace(/^Bearer\s+/i, "")
    const part = raw.split(".")[1]
    if (!part) {
      return null
    }
    const base64 = part.replace(/-/g, "+").replace(/_/g, "/")
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4)
    const json = decodeURIComponent(
      atob(padded)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    )
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}
